"use client";import{useEffect as t}from"react";import{preventScroll as e,allowScroll as r}from"./usePreventScroll.utils.js";const o=(o=!0)=>{t((()=>(o&&e(),()=>{o&&r()})),[o])};export{o as default};
